import React from 'react';

const Feedback = () => {
  const feedbacks = [
    { id: 1, image: "feedback1", alt: "Feedback do Cliente 1" },
    { id: 2, image: "feedback2", alt: "Feedback do Cliente 2" },
    { id: 3, image: "feedback3", alt: "Feedback do Cliente 3" },
    { id: 4, image: "feedback4", alt: "Feedback do Cliente 4" },
    { id: 6, image: "feedback6", alt: "Feedback do Cliente 6" },
    { id: 7, image: "feedback7", alt: "Feedback do Cliente 7" },
    { id: 8, image: "feedback8", alt: "Feedback do Cliente 8" }
  ];

  // Triplicar feedbacks para efeito de loop infinito mais suave
  const duplicatedFeedbacks = [...feedbacks, ...feedbacks, ...feedbacks];

  return (
    <section className="feedback" id="feedback">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">O que nossos clientes dizem</h2>
        
        <div className="feedback-carousel-wrapper">
          <div className="feedback-carousel">
            <div className="feedback-track">
              {duplicatedFeedbacks.map((feedback, index) => (
                <div key={`${feedback.id}-${index}`} className="feedback-item">
                  <picture>
                    <source srcSet={`/${feedback.image}.webp`} type="image/webp" />
                    <img 
                      src={`/${feedback.image}.jpg`} 
                      alt={feedback.alt}
                      loading="lazy"
                    />
                  </picture>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="simple-line"></div>
      </div>
    </section>
  );
};

export default Feedback;